import { render } from "./ProfessionalAssociation.vue?vue&type=template&id=bac36a12&scoped=true"
import script from "./ProfessionalAssociation.vue?vue&type=script&lang=js"
export * from "./ProfessionalAssociation.vue?vue&type=script&lang=js"

import "./ProfessionalAssociation.vue?vue&type=style&index=0&id=bac36a12&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac36a12"]])

export default __exports__